import { NativeStackScreenProps } from "@react-navigation/native-stack";
import {
  AiInsightsActionsRootScreenParamList,
  AiInsightsRootModalScreenParamList,
  ProductAiInsightsActionsRootScreenParamList,
  ProductAiInsightsRootModalScreenParamList,
} from "../../../../types";
import React from "react";
import { ActionsScreenContext } from "./common";
import {
  createStackHeaderNavigator,
  ModalCloseButton,
} from "@towersystems/roam-common-native";
import { useLazyQuery } from "@apollo/client";
import { QUERY_QUICK_WIN_RESULT_BY_ID } from "../../../../utilities/llm-quick-wins";
import { CardStyleInterpolators } from "@react-navigation/stack";
import { ProductAiInsightsActionsEnterEmailScreen } from "./ProductAiInsightsActionsEnterEmailScreen";
import { ProductAiInsightsActionsListScreen } from "./ProductAiInsightsActionsListScreen";

export type ProductAiInsightsActionsRootScreenProps = NativeStackScreenProps<
  ProductAiInsightsRootModalScreenParamList,
  "ProductAiInsightsActionsRootScreen"
>;

const Stack =
  createStackHeaderNavigator<ProductAiInsightsActionsRootScreenParamList>();

export const ProductAiInsightsActionsRootScreen = ({
  route,
}: ProductAiInsightsActionsRootScreenProps) => {
  const { resultId } = route.params;

  const [result, setResult] = React.useState<
    | {
        result?: string;
        id: string;
      }
    | undefined
  >(undefined);

  const [q] = useLazyQuery<{
    quickWinResultById: {
      id: string;
      result?: string;
    };
  }>(QUERY_QUICK_WIN_RESULT_BY_ID);

  React.useEffect(() => {
    q({
      variables: {
        id: resultId,
      },
    })
      .then((response) => {
        const result = response.data?.quickWinResultById;
        if (result) {
          setResult(result);
        }
      })
      .catch((error) => {
        // Handle error case
      });
  }, [resultId]);

  return (
    <ActionsScreenContext.Provider
      value={{
        resultId,
        result: result
          ? {
              id: result.id,
              result: result.result ?? "",
            }
          : undefined,
      }}
    >
      <Stack.Navigator
        screenOptions={{
          headerShown: true,
          headerLeft: () => <ModalCloseButton type="Close" />,
          animationEnabled: true,
          cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
          title: "",
        }}
      >
        <Stack.Screen
          name="ProductAiInsightsActionsListScreen"
          component={ProductAiInsightsActionsListScreen}
        />
        <Stack.Screen
          name="ProductAiInsightsActionsEnterEmailScreen"
          component={ProductAiInsightsActionsEnterEmailScreen}
        />
      </Stack.Navigator>
    </ActionsScreenContext.Provider>
  );
};
